import AboutIcon from 'assets/images/about/about.svg';
const About = () => {
  return (
    <div className=" mx-3 text-justify">
      <img src={AboutIcon} alt="about" className=" block mx-auto mt-6" />
      <p className=" text-gray-6 mb-8 pb-8">
        زمانی که فناوری اطلاعات به کمک کسب و کارهای مختلف آمد، تغييری در زنجیره
        ارزش محصولات کشاورزی ایران ایجاد نشد. متوجه شدیم مشکل اصلی نداشتن
        اطلاعات ضروری برای مدیریت بهتر زنجیره تامین کشاورزی هست. داستان مزرعه
        سال ۱۳۹۸ با چند کشاورز و مهندس برای ایجاد تغيير شروع شد. مزرعه طی چند
        سال شروع به مطالعه و ساخت نرم افزار ساده ای کرد تا رویدادهای دنیای واقعی
        زنجیره تامین کشاورزی را برخط کند. اکنون هزاران کشاورز با اپلیکیشن مزرعه
        کار می کنند و تامین‌کنندگان و عمده فروشان بیشتر از هر زمان دیگری به
        داده‌ها در حلقه تولید کشاورزی دسترسی دارند. اکنون مزرعه این امکان را
        برای فعالان حوزه کشاورزی فراهم کرده تا بتوانند محصولات خود را در بستری
        تخصصی مانند مزایده، حراجی و سلف در بازار عمده فروشان بفروشند. ما همواره
        در تلاشیم تا با به کارگیری فناوریهای روز دنیا به بهبود بازیگران زنجیره
        تامین کشاورزی و ایجاد ارتباط مستقیم آن‌ها با یکدیگر بپردازیم.
      </p>
    </div>
  );
};

export default About;
